import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { SwipeableListItem } from '../../../../../generic/swipe/SwipeableListAdapter';
import { LINKS } from '../../../../../Routs/config';
import { SwipeAction } from '../../../../../generic/ui/SwipeAction';
import PencilIcon from '../../../../../generic/icons/IconLib/PencilIcon';
import PrintIcon from '../../../../../generic/icons/IconLib/PrintIcon';
import { convertToDate } from '../../../../../modules/convertDateString';
import { stringToTime } from '../generic/helpers/convert';
import { useTranslation } from 'react-i18next';
import { IEntrie } from '../../../../../modules/API/Knisot/models/entrie';
import { KnisotPrintHandler } from '../types';
import EntryRow from './EntryRow';

type Props = IEntrie & {
    isLast?: boolean;
    handlePrintKnisa: KnisotPrintHandler;
};

const KnisotRowItem: React.FC<Props> = ({
    EntryNum,
    EntryDate,
    EntryTime,
    GrowerName,
    Reference,
    isLast = false,
    handlePrintKnisa,
}) => {
    const navigate = useNavigate();
    const [t] = useTranslation('knisa');

    const date = convertToDate(EntryDate);
    const time = stringToTime(EntryTime);

    const handleEdit = () => {
        navigate(`${LINKS.knisot.teudot.editByID}${EntryNum}`);
    };

    const handlePrintClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        handlePrintKnisa(EntryNum);
    };

    return (
        <Wrapper>
            <SwipeableListItem
                swipeRight={{
                    content: (
                        <SwipeAction
                            variant='edit'
                            align='start'
                            icon={<PencilIcon />}
                            label={t('knisa_create_element_swipe_edit')}
                        />
                    ),
                    action: handleEdit,
                }}
                threshold={0.3}
            >
                <EntryRow
                    entryNum={EntryNum}
                    reference={Reference}
                    primary={GrowerName?.trim() ?? ''}
                    date={date}
                    time={time}
                    isLast={isLast}
                    trailing={
                        <PrintBtn type='button' onClick={handlePrintClick} aria-label={t('knisa_create_element_print_aria')}>
                            <PrintIcon />
                        </PrintBtn>
                    }
                />
            </SwipeableListItem>
        </Wrapper>
    );
};

export default KnisotRowItem;

const Wrapper = styled.div`
    width: 100%;
`;

const PrintBtn = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    height: 2rem;
    min-width: 2rem;
    padding: 0 0.5rem;
    border-radius: 0.5rem;
    background: ${({ theme }) => theme.colors.accent};
    color: ${({ theme }) => theme.colors.ink};
    border: 1px solid ${({ theme }) => theme.colors.accent};
    cursor: pointer;
    user-select: none;
    transition: all ${({ theme }) => theme.motion.fast} ease;

    svg {
        width: 1rem;
        height: 1rem;
    }

    &:hover {
        background: ${({ theme }) => theme.colors.accentDeep};
        border-color: ${({ theme }) => theme.colors.accentDeep};
    }

    &:active {
        transform: translateY(1px);
    }
`;
